"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_STATUS = void 0;
exports.ORDER_STATUS = {
    PENDING: 'PENDING',
    OPENED: 'OPENED',
    NEW: 'NEW',
    DISPATCHED: 'DISPATCHED',
    SHIPPING: 'SHIPPING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
    CANCELLING: 'CANCELLING',
    HOLD: 'HOLD'
};
//# sourceMappingURL=orderStatus.js.map